import {
  GlobalProductInterface,
  GlobalVariantInterface,
} from '@/models/shop/GlobalProduct.types'
import GlobalProductsApi from '@/services/shop/GlobalProductsApi'

export class GlobalProductDTO implements GlobalProductInterface {
  id = ''
  category_id = ''
  name = ''
  description = ''
  image = ''
  sort_order = 0
  track_stock = false
  created_at = ''
  updated_at = ''
  variants: GlobalVariantInterface[] = []
}

export default class GlobalProduct extends GlobalProductDTO {
  static api = GlobalProductsApi

  constructor(DTO: GlobalProductDTO) {
    super()
    Object.assign(this, DTO)
  }
}
